<div class="grid grid-cols-12 gap-1 mb-1">
	<div
		[class.bg-grey-lime]="message.notAParticipant$ | async"
		[class.p-background-color-primary-pastel]="
			(message.mine$ | async) && !(message.notAParticipant$ | async)
		"
		[class.p-background-color-secondary-pastel]="
			!(message.mine$ | async) && !(message.notAParticipant$ | async)
		"
		[class.p-color-primary]="
			(message.mine$ | async) && !(message.notAParticipant$ | async)
		"
		[class.p-color-secondary]="
			!(message.mine$ | async) && !(message.notAParticipant$ | async)
		"
		[class.text-gray-400]="message.notAParticipant$ | async"
		class="
			flex flex-auto flex-grow-0 flex-shrink-0
			items-center
			justify-center
			rounded-full
			w-8
			h-8
		"
	>
		{{ (message.message.author$ | async)?.acronym }}
	</div>
	<div class="px-3 flex-1 col-span-9">
		<div
			[class.text-gray-500]="message.notAParticipant$ | async"
			class="font-medium"
		>
			{{ (message.message.author$ | async)?.name }}
		</div>
		<div
			[class.text-gray-500]="message.notAParticipant$ | async"
			class="p-color-text"
		>
			{{ message.message.content }}
		</div>
	</div>
	<div
		class="
			flex-auto flex-shrink-0 flex-grow-0
			text-xs
			p-color-text-secondary
			col-span-2
		"
	>
		{{ message.message.date | date: 'shortTime' }}
	</div>
</div>
<spr-message-attachment
	*ngIf="
		message.message.documentId ||
		message.message.moduleId ||
		message.message.visioSessionId
	"
	[document]="message.message.document$ | async"
	[module]="message.message.module$ | async"
	[userId]="message.message.authorId"
	[visioSessionId]="message.message.visioSessionId"
	(visioOpen)="visioOpen.emit($event)"
></spr-message-attachment>
